import { useContext } from 'react';

import { UiContext } from '..';

export const useUiContext = () => useContext(UiContext);
